module.exports = __webpack_public_path__ + "img/img5.200c4261.gif";